// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9d3ea2d8","455":"7a782867","977":"ed398171"}[chunkId] + ".chunk.js";
};